var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupyou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7554 1.13037C20.7904 1.13037 26.4854 6.82537 26.4854 13.8604C26.4854 20.8954 20.7904 26.5904 13.7554 26.5904C6.72039 26.5904 1.02539 20.8954 1.02539 13.8604C1.02539 6.82537 6.72039 1.13037 13.7554 1.13037Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1947 18.4833C7.6587 18.2823 7.3237 17.9473 7.1227 17.4113C6.6537 16.1383 6.5197 10.7783 7.3907 9.70629C7.7257 9.37129 8.0607 9.10329 8.5967 9.10329C11.0087 8.83529 18.5127 8.90229 19.3837 9.17029C19.9197 9.37129 20.2547 9.70629 20.4557 10.1753C20.9917 11.5153 20.9917 16.3393 20.3887 17.6123C20.2547 17.9473 19.9867 18.2153 19.6517 18.3493C18.6467 18.8853 9.4007 18.8853 8.1947 18.4833ZM12.0137 16.0043C13.4877 15.2673 14.8947 14.5303 16.3687 13.7263C14.8947 12.9893 13.4877 12.1853 12.0137 11.4483C12.0137 12.9893 12.0137 14.4633 12.0137 16.0043Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupyou);
export default __webpack_public_path__ + "static/media/Group you.bef9df8a74e88dd8cb24f84ff93d5b28.svg";
export { ForwardRef as ReactComponent };